// extracted by css-extract-rspack-plugin
export default {"Wrapper":"PartOfCampaignInfo_Wrapper__GT3cw","Content":"PartOfCampaignInfo_Content__BYwQQ","Title":"PartOfCampaignInfo_Title__rxaIe","Image":"PartOfCampaignInfo_Image__TsUjF"};